










import { Component, Vue, Prop } from 'vue-property-decorator';
import InboundDeliveryOrderCharge from '@/views/components/inboundDeliveryOrderCharge/index.vue';
import Breadcrumb, { BreadcrumbOption } from '@/components/breadcrumb/index.vue';
@Component({
  components: {
    Breadcrumb,
    InboundDeliveryOrderCharge,
  },
})
export default class ChargesDetail extends Vue {
  /** 面包屑 */
  private breadcrumbData: BreadcrumbOption[] = [
    {
      title: this.t('入库单详情'),
      routerName: 'InboundOrderDetailPage',
      query: {
        code: this.$route.query.code,
        order_type: this.$route.query.order_type,
        name: 'InboundOrderPage',
      },
    },
    { title: this.t('海外仓入库费用明细') },
  ];
}
